import api from '../client'

export const userApi = {
  list: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/users`)
    return response.data
  },
  
  get: async (orgSlug, userId) => {
    const response = await api.get(`/${orgSlug}/users/${userId}`)
    return response.data
  },
  
  create: async (orgSlug, userData) => {
    const response = await api.post(`/${orgSlug}/users`, userData)
    return response.data
  },
  
  update: async (orgSlug, userId, updates) => {
    const response = await api.patch(`/${orgSlug}/users/${userId}`, updates)
    return response.data
  },
  
  updateRole: async (orgSlug, userId, role) => {
    const response = await api.post(`/${orgSlug}/users/${userId}/role`, { role })
    return response.data
  },
  
  toggleActive: async (orgSlug, userId, isActive) => {
    const response = await api.post(`/${orgSlug}/users/${userId}/toggle-active`, { is_active: isActive })
    return response.data
  },
  
  delete: async (orgSlug, userId) => {
    await api.delete(`/${orgSlug}/users/${userId}`)
  },

  resendInvitation: async (orgSlug, inviteId) => {
    const response = await api.post(`/${orgSlug}/users/invitations/${inviteId}/resend`)
    return response.data
  },

  createInvitationLink: async (orgSlug, inviteId) => {
    const response = await api.post(`/${orgSlug}/users/invitations/${inviteId}/link`)
    return response.data
  },

  cancelInvitation: async (orgSlug, inviteId) => {
    const response = await api.delete(`/${orgSlug}/users/invitations/${inviteId}`)
    return response.data
  },
  resetMFA: async (orgSlug, userId) => {
    const response = await api.post(`/${orgSlug}/users/${userId}/reset-mfa`)
    return response.data
  },
}

export const platformUserApi = {
  list: async () => {
    const response = await api.get('/platform/users/')
    return response.data
  },

  listOrganizations: async () => {
    const response = await api.get('/platform/users/organizations')
    return response.data
  },

  getAccess: async (userId) => {
    const response = await api.get(`/platform/users/${userId}/access`)
    return response.data
  },

  updateAccess: async (userId, access) => {
    const response = await api.put(`/platform/users/${userId}/access`, access)
    return response.data
  },

  resendInvitation: async (userId) => {
    const response = await api.post(`/platform/users/${userId}/invitation/resend`)
    return response.data
  },

  createInvitationLink: async (userId) => {
    const response = await api.post(`/platform/users/${userId}/invitation/link`)
    return response.data
  },

  cancelInvitation: async (userId) => {
    const response = await api.delete(`/platform/users/${userId}/invitation`)
    return response.data
  },

  invite: async (user) => {
    const response = await api.post('/platform/users/', user)
    return response.data
  },
}
